import { create } from 'zustand';

export type ChatViewMode = 'collapsed' | 'sidebar' | 'fullscreen';

interface UIState {
  chatViewMode: ChatViewMode;
  isHistoryPanelVisibleOnMobile: boolean;
  isInitializingChat: boolean;
  setChatViewMode: (mode: ChatViewMode) => void;
  toggleHistoryPanelVisibility: () => void;
  setIsInitializingChat: (isInitializing: boolean) => void;
  // Potentially, add functions to open to specific views directly
  openChatToSidebar: () => void;
  openChatToFullscreen: () => void;
  closeChatToBubble: () => void;
  minimizeChatToSidebar: () => void; // If fullscreen can go back to sidebar
}

export const useUIStore = create<UIState>((set) => ({
  chatViewMode: 'collapsed', // Initial state
  isHistoryPanelVisibleOnMobile: false, // Initial state
  isInitializingChat: false,
  setChatViewMode: (mode) => set({ chatViewMode: mode }),
  toggleHistoryPanelVisibility: () =>
    set((state) => ({
      isHistoryPanelVisibleOnMobile: !state.isHistoryPanelVisibleOnMobile,
    })),
  setIsInitializingChat: (isInitializing) => set({ isInitializingChat: isInitializing }),
  openChatToSidebar: () => set({ chatViewMode: 'sidebar', isHistoryPanelVisibleOnMobile: false }), // Ensure history panel is hidden when opening to sidebar
  openChatToFullscreen: () => set({ chatViewMode: 'fullscreen' }),
  closeChatToBubble: () => set({ chatViewMode: 'collapsed', isHistoryPanelVisibleOnMobile: false }),
  minimizeChatToSidebar: () => set({ chatViewMode: 'sidebar', isHistoryPanelVisibleOnMobile: false }),
})); 